{
  "familyId": "GELD-WISSEL",
  "questions": [
    {
      "id": "GELD-WISSEL-001",
      "familyId": "GELD-WISSEL",
      "module": "Geld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een kassamedewerker rekent af: een snoepje kost €0,75. De klant betaalt met €1,00. Hoeveel wisselgeld geeft de kassamedewerker terug?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€0,25", "€0,75", "€0,30", "€0,20"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 75,
          "paidCents": 100,
          "targetCents": 25,
          "allowedDenoms": [
            { "valueCents": 50, "type": "coin", "label": "50 cent" },
            { "valueCents": 20, "type": "coin", "label": "20 cent" },
            { "valueCents": 10, "type": "coin", "label": "10 cent" },
            { "valueCents": 5, "type": "coin", "label": "5 cent" }
          ],
          "constraints": { "maxTokens": 5 }
        }
      },
      "conceptId": "give_change_quarters",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.change-calculation", "label": "Geeft de prijs terug i.p.v. het wisselgeld (€0,75)", "optionIndex": 1 },
        { "id": "geld.boodschappen-centen-aftrekfout", "label": "Aftrekfout in de centen: 100 − 75 = 30 (€0,30)", "optionIndex": 2 },
        { "id": "geld.munt-vergeten", "label": "Vergeet de 5-centmunt (alleen €0,20)", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 100, "showCoins": true, "label": "De klant betaalt met €1,00", "breakdown": { "coins": [{ "value": 100, "count": 1 }], "bills": [] } } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Wisselgeld berekenen", "content": "Wisselgeld = betaald − prijs = €1,00 − €0,75 = €0,25. Geef terug: 20 cent + 5 cent = 25 cent." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Wisselgeld bereken je door de prijs van het betaalde bedrag af te trekken. De klant betaalt €1,00 en het snoepje kost €0,75. Wisselgeld = €1,00 − €0,75 = €0,25. De kassamedewerker geeft 20 cent + 5 cent = 25 cent terug.",
        "solutionSteps": [
          "Betaald: €1,00, prijs: €0,75",
          "Wisselgeld = €1,00 − €0,75 = €0,25",
          "Geef terug: 20 cent + 5 cent = 25 cent"
        ],
        "distractorExplanations": {
          "0": "Goed! Wisselgeld = €1,00 − €0,75 = €0,25.",
          "1": "Je dacht waarschijnlijk dat de prijs het wisselgeld is. Maar €0,75 is wat het snoepje kost, niet wat je terugkrijgt. Onthoud: wisselgeld = betaald − prijs.",
          "2": "Je dacht waarschijnlijk dat €1,00 − €0,75 = €0,30. Maar 100 − 75 = 25 cent, niet 30 cent. Onthoud: controleer je aftreksom altijd door op te tellen: €0,75 + €0,25 = €1,00 ✓.",
          "3": "Je dacht waarschijnlijk dat je alleen 20 cent teruggeeft. Maar €0,20 is 5 cent te weinig. Onthoud: 20 + 5 = 25 cent. Controleer: €0,75 + €0,25 = €1,00 ✓."
        }
      }
    },
    {
      "id": "GELD-WISSEL-002",
      "familyId": "GELD-WISSEL",
      "module": "Geld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een winkelier verkoopt een pen voor €1,25. De klant betaalt met €2,00. Hoeveel wisselgeld krijgt de klant terug?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€0,75", "€1,25", "€0,80", "€0,70"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 125,
          "paidCents": 200,
          "targetCents": 75,
          "allowedDenoms": [
            { "valueCents": 50, "type": "coin", "label": "50 cent" },
            { "valueCents": 20, "type": "coin", "label": "20 cent" },
            { "valueCents": 10, "type": "coin", "label": "10 cent" },
            { "valueCents": 5, "type": "coin", "label": "5 cent" }
          ],
          "constraints": { "maxTokens": 5 }
        }
      },
      "conceptId": "give_change_euros",
      "variantIndex": 2,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.79,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.change-calculation", "label": "Geeft de prijs terug i.p.v. het wisselgeld (€1,25)", "optionIndex": 1 },
        { "id": "geld.boodschappen-centen-aftrekfout", "label": "Aftrekfout in de centen: 200 − 125 = 80 (€0,80)", "optionIndex": 2 },
        { "id": "geld.munt-vergeten", "label": "Vergeet de 5-centmunt (€0,70)", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 200, "showCoins": true, "label": "De klant betaalt met €2,00", "breakdown": { "coins": [{ "value": 200, "count": 1 }], "bills": [] } } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Wisselgeld met euros", "content": "Wisselgeld = €2,00 − €1,25 = €0,75. Geef terug: 50 cent + 20 cent + 5 cent = 75 cent." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "De klant betaalt €2,00 en de pen kost €1,25. Wisselgeld = €2,00 − €1,25 = €0,75. De winkelier geeft 50 cent + 20 cent + 5 cent = 75 cent terug.",
        "solutionSteps": [
          "Betaald: €2,00, prijs: €1,25",
          "Wisselgeld = €2,00 − €1,25 = €0,75",
          "Geef terug: 50 cent + 20 cent + 5 cent = 75 cent"
        ],
        "distractorExplanations": {
          "0": "Goed! Wisselgeld = €2,00 − €1,25 = €0,75.",
          "1": "Je dacht waarschijnlijk dat de prijs het wisselgeld is. Maar €1,25 is de prijs van de pen, niet het wisselgeld. Onthoud: wisselgeld = betaald − prijs.",
          "2": "Je dacht waarschijnlijk dat 200 − 125 = 80. Maar 200 − 125 = 75 cent, niet 80 cent. Onthoud: controleer door op te tellen: €1,25 + €0,75 = €2,00 ✓.",
          "3": "Je dacht waarschijnlijk dat je de 5 cent niet hoeft terug te geven. Maar €0,70 is 5 cent te weinig. Onthoud: 50 + 20 + 5 = 75 cent."
        }
      }
    },
    {
      "id": "GELD-WISSEL-003",
      "familyId": "GELD-WISSEL",
      "module": "Geld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een snackbarhouder rekent af: een ijsje kost €3,65. De klant betaalt met €5,00. Hoeveel wisselgeld krijgt de klant?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€1,35", "€8,65", "€1,45", "€3,65"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 365,
          "paidCents": 500,
          "targetCents": 135,
          "allowedDenoms": [
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50, "type": "coin", "label": "50 cent" },
            { "valueCents": 20, "type": "coin", "label": "20 cent" },
            { "valueCents": 10, "type": "coin", "label": "10 cent" },
            { "valueCents": 5, "type": "coin", "label": "5 cent" }
          ],
          "constraints": { "maxTokens": 6 }
        }
      },
      "conceptId": "give_change_complex",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.optellen-ipv-aftrekken", "label": "Telt op i.p.v. af te trekken (€8,65)", "optionIndex": 1 },
        { "id": "geld.boodschappen-centen-aftrekfout", "label": "Aftrekfout in de centen: 100 − 65 = 45 (€1,45)", "optionIndex": 2 },
        { "id": "geld.change-calculation", "label": "Geeft de prijs terug i.p.v. het wisselgeld (€3,65)", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 500, "showBills": true, "label": "De klant betaalt met €5,00", "breakdown": { "coins": [], "bills": [{ "value": 500, "count": 1 }] } } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Wisselgeld stap voor stap", "content": "Wisselgeld = €5,00 − €3,65. Reken: €5,00 − €3,00 = €2,00, dan €2,00 − €0,65 = €1,35. Geef terug: €1 + 20c + 10c + 5c." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Bij grotere bedragen splits je het aftrekken in euro's en centen. €5,00 − €3,00 = €2,00, dan €2,00 − €0,65 = €1,35. De snackbarhouder geeft €1 + 20 cent + 10 cent + 5 cent terug.",
        "solutionSteps": [
          "Betaald: €5,00, prijs: €3,65",
          "Euro's aftrekken: €5,00 − €3,00 = €2,00",
          "Centen aftrekken: €2,00 − €0,65 = €1,35",
          "Geef terug: €1 + 20c + 10c + 5c = €1,35"
        ],
        "distractorExplanations": {
          "0": "Goed! Wisselgeld = €5,00 − €3,65 = €1,35.",
          "1": "Je dacht waarschijnlijk dat je moet optellen in plaats van aftrekken. €8,65 = €5,00 + €3,65. Onthoud: bij wisselgeld trek je af: betaald − prijs.",
          "2": "Je dacht waarschijnlijk dat 100 − 65 = 45. Maar 100 − 65 = 35 cent, niet 45 cent. Onthoud: controleer door op te tellen: €3,65 + €1,35 = €5,00 ✓.",
          "3": "Je dacht waarschijnlijk dat de prijs het wisselgeld is. Maar €3,65 is wat het ijsje kost. Onthoud: wisselgeld = betaald − prijs = €5,00 − €3,65 = €1,35."
        }
      }
    },
    {
      "id": "GELD-WISSEL-004",
      "familyId": "GELD-WISSEL",
      "module": "Geld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een kaartjesverkoper bij de bioscoop verkoopt een kaartje van €4,50. De bezoeker betaalt met €10,00. Hoeveel wisselgeld krijgt de bezoeker terug?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€5,50", "€5,00", "€6,00", "€4,50"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 450,
          "paidCents": 1000,
          "targetCents": 550,
          "allowedDenoms": [
            { "valueCents": 500, "type": "bill", "label": "€5" },
            { "valueCents": 200, "type": "coin", "label": "€2" },
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50, "type": "coin", "label": "50 cent" }
          ],
          "constraints": { "maxTokens": 5 }
        }
      },
      "conceptId": "give_change_large",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.munt-vergeten", "label": "Vergeet de 50 cent af te trekken (€5,00)", "optionIndex": 1 },
        { "id": "geld.change-calculation", "label": "Trekt alleen de hele euro's af (€6,00)", "optionIndex": 2 },
        { "id": "geld.change-calculation", "label": "Geeft de prijs terug i.p.v. het wisselgeld (€4,50)", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 1000, "showBills": true, "label": "De bezoeker betaalt met €10,00", "breakdown": { "coins": [], "bills": [{ "value": 1000, "count": 1 }] } } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Groot wisselgeld", "content": "Wisselgeld = €10,00 − €4,50 = €5,50. Reken: €10,00 − €4,00 = €6,00, dan €6,00 − €0,50 = €5,50. Geef terug: €5 biljet + 50 cent." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "Bij grotere bedragen splits je het aftrekken. €10,00 − €4,00 = €6,00, dan €6,00 − €0,50 = €5,50. De kaartjesverkoper geeft een €5 biljet + 50 cent terug.",
        "solutionSteps": [
          "Betaald: €10,00, prijs: €4,50",
          "Euro's aftrekken: €10,00 − €4,00 = €6,00",
          "Centen aftrekken: €6,00 − €0,50 = €5,50",
          "Geef terug: €5 biljet + 50 cent = €5,50"
        ],
        "distractorExplanations": {
          "0": "Goed! Wisselgeld = €10,00 − €4,50 = €5,50.",
          "1": "Je dacht waarschijnlijk dat je de 50 cent niet hoeft af te trekken. Maar €10,00 − €4,50 = €5,50, niet €5,00. Onthoud: vergeet de centen niet bij het aftrekken.",
          "2": "Je dacht waarschijnlijk dat €10,00 − €4,00 het antwoord is. Maar je vergeet de 50 cent: €6,00 − €0,50 = €5,50. Onthoud: trek altijd het volledige bedrag af, inclusief centen.",
          "3": "Je dacht waarschijnlijk dat de prijs het wisselgeld is. Maar €4,50 is de prijs van het kaartje. Onthoud: wisselgeld = betaald − prijs = €10,00 − €4,50 = €5,50."
        }
      }
    },
    {
      "id": "GELD-WISSEL-005",
      "familyId": "GELD-WISSEL",
      "module": "Geld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een marktkoopman verkoopt een drankje voor €2,35. De klant betaalt met €5,00. Hoeveel wisselgeld krijgt de klant?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€2,65", "€2,60", "€2,70", "€3,00"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 235,
          "paidCents": 500,
          "targetCents": 265,
          "allowedDenoms": [
            { "valueCents": 200, "type": "coin", "label": "€2" },
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50, "type": "coin", "label": "50 cent" },
            { "valueCents": 20, "type": "coin", "label": "20 cent" },
            { "valueCents": 10, "type": "coin", "label": "10 cent" },
            { "valueCents": 5, "type": "coin", "label": "5 cent" }
          ],
          "constraints": { "maxTokens": 6 }
        }
      },
      "conceptId": "give_change_precise",
      "variantIndex": 5,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.77,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.munt-vergeten", "label": "Vergeet de 5-centmunt (€2,60)", "optionIndex": 1 },
        { "id": "geld.boodschappen-centen-aftrekfout", "label": "Aftrekfout in de centen: 100 − 35 = 70 (€2,70)", "optionIndex": 2 },
        { "id": "geld.change-calculation", "label": "Trekt alleen de hele euro's af (€3,00)", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 500, "showBills": true, "label": "De klant betaalt met €5,00", "breakdown": { "coins": [], "bills": [{ "value": 500, "count": 1 }] } } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Precies wisselgeld", "content": "Wisselgeld = €5,00 − €2,35 = €2,65. Reken: €5,00 − €2,00 = €3,00, dan €3,00 − €0,35 = €2,65. Geef terug: €2 + 50c + 10c + 5c." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "De klant betaalt €5,00 en het drankje kost €2,35. Splits het aftrekken: €5,00 − €2,00 = €3,00, dan €3,00 − €0,35 = €2,65. De marktkoopman geeft €2 + 50 cent + 10 cent + 5 cent terug.",
        "solutionSteps": [
          "Betaald: €5,00, prijs: €2,35",
          "Euro's aftrekken: €5,00 − €2,00 = €3,00",
          "Centen aftrekken: €3,00 − €0,35 = €2,65",
          "Geef terug: €2 + 50c + 10c + 5c = €2,65"
        ],
        "distractorExplanations": {
          "0": "Goed! Wisselgeld = €5,00 − €2,35 = €2,65.",
          "1": "Je dacht waarschijnlijk dat je de 5 cent niet hoeft terug te geven. Maar €2,60 is 5 cent te weinig. Onthoud: 100 − 35 = 65 cent, niet 60 cent.",
          "2": "Je dacht waarschijnlijk dat 100 − 35 = 70. Maar 100 − 35 = 65 cent, niet 70 cent. Onthoud: controleer door op te tellen: €2,35 + €2,65 = €5,00 ✓.",
          "3": "Je dacht waarschijnlijk dat je alleen de euro's aftrekt. Maar €5,00 − €2,00 = €3,00 is niet het volledige antwoord. Onthoud: trek ook de centen af: €3,00 − €0,35 = €2,65."
        }
      }
    },
    {
      "id": "GELD-WISSEL-006",
      "familyId": "GELD-WISSEL",
      "module": "Geld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "money",
      "question": "Een bioscoopmedewerker verkoopt een kaartje van €6,80. De bezoeker betaalt met €10,00. Hoeveel wisselgeld geeft de medewerker terug?",
      "_validationSource": "assembler",
      "_note": "options and correctAnswer are display metadata only - validation via data.money.targetCents",
      "options": ["€3,20", "€3,00", "€3,30", "€4,00"],
      "correctAnswer": 0,
      "data": {
        "money": {
          "mode": "give_change",
          "currency": "EUR",
          "priceCents": 680,
          "paidCents": 1000,
          "targetCents": 320,
          "allowedDenoms": [
            { "valueCents": 200, "type": "coin", "label": "€2" },
            { "valueCents": 100, "type": "coin", "label": "€1" },
            { "valueCents": 50, "type": "coin", "label": "50 cent" },
            { "valueCents": 20, "type": "coin", "label": "20 cent" },
            { "valueCents": 10, "type": "coin", "label": "10 cent" }
          ],
          "constraints": { "maxTokens": 6 }
        }
      },
      "conceptId": "give_change_twenties",
      "variantIndex": 6,
      "citoDifficulty": 0.23,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.munt-vergeten", "label": "Vergeet de 80 cent af te trekken (€3,00)", "optionIndex": 1 },
        { "id": "geld.boodschappen-centen-aftrekfout", "label": "Aftrekfout in de centen: 100 − 80 = 30 (€3,30)", "optionIndex": 2 },
        { "id": "geld.change-calculation", "label": "Trekt alleen de hele euro's af (€4,00)", "optionIndex": 3 }
      ] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 1000, "showBills": true, "label": "De bezoeker betaalt met €10,00", "breakdown": { "coins": [], "bills": [{ "value": 1000, "count": 1 }] } } }],
      "supportAids": [{ "type": "rule", "data": { "title": "Wisselgeld met 20 cent", "content": "Wisselgeld = €10,00 − €6,80 = €3,20. Reken: €10,00 − €6,00 = €4,00, dan €4,00 − €0,80 = €3,20. Geef terug: €2 + €1 + 20c." }, "showWhen": "wrong" }],
      "feedback": {
        "explanationText": "De bezoeker betaalt €10,00 en het kaartje kost €6,80. Splits het aftrekken: €10,00 − €6,00 = €4,00, dan €4,00 − €0,80 = €3,20. De bioscoopmedewerker geeft €2 + €1 + 20 cent terug.",
        "solutionSteps": [
          "Betaald: €10,00, prijs: €6,80",
          "Euro's aftrekken: €10,00 − €6,00 = €4,00",
          "Centen aftrekken: €4,00 − €0,80 = €3,20",
          "Geef terug: €2 + €1 + 20c = €3,20"
        ],
        "distractorExplanations": {
          "0": "Goed! Wisselgeld = €10,00 − €6,80 = €3,20.",
          "1": "Je dacht waarschijnlijk dat je de 80 cent niet hoeft af te trekken. Maar €3,00 is 20 cent te weinig. Onthoud: 100 − 80 = 20 cent, dus het wisselgeld is €3,20.",
          "2": "Je dacht waarschijnlijk dat 100 − 80 = 30. Maar 100 − 80 = 20 cent, niet 30 cent. Onthoud: controleer door op te tellen: €6,80 + €3,20 = €10,00 ✓.",
          "3": "Je dacht waarschijnlijk dat je alleen de euro's aftrekt. Maar €10,00 − €6,00 = €4,00 is niet het volledige antwoord. Onthoud: trek ook de centen af: €4,00 − €0,80 = €3,20."
        }
      }
    },
    {
      "id": "GELD-WISSEL-007",
      "familyId": "GELD-WISSEL",
      "module": "Geld",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_wisselgeld",
      "questionType": "fill_in",
      "question": "Een bakker verkoopt een broodje van €3,50. De klant betaalt met een briefje van €5. Hoeveel wisselgeld geeft de bakker terug?",
      "options": ["€1,50", "€1,00", "€2,00", "€2,50"],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["€1,50", "1,50", "1.50", "150"],
        "fill_in": {
          "inputType": "text",
          "placeholder": "€0,00",
          "unit": "",
          "acceptedAnswers": ["€1,50", "1,50", "1.50", "150"]
        },
        "money": {
          "mode": "give_change",
          "priceCents": 350,
          "paidCents": 500,
          "targetCents": 150,
          "currency": "EUR"
        }
      },
      "supportAids": [
        { "type": "money", "showWhen": "correct", "data": { "amount": 150, "showCoins": true, "showBills": false, "label": "Wisselgeld: €1,50" } }
      ],
      "conceptId": "money_change_calculation",
      "variantIndex": 7,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.79,
      "pedagogy": { "dok": 2, "misconceptionTags": [
        { "id": "geld.change-calculation", "label": "Geeft de prijs terug i.p.v. het wisselgeld" },
        { "id": "geld.boodschappen-centen-aftrekfout", "label": "Aftrekfout in de centen bij €5,00 − €3,50" }
      ] },
      "stimulusAids": [{ "type": "money", "data": { "amount": 500, "showBills": true, "label": "De klant betaalt met €5,00", "breakdown": { "coins": [], "bills": [{ "value": 500, "count": 1 }] } } }],
      "feedback": {
        "explanationText": "De bakker rekent: wisselgeld = betaald − prijs. De klant betaalt €5,00 en het broodje kost €3,50. Wisselgeld = €5,00 − €3,50 = €1,50. De bakker geeft €1 + 50 cent = €1,50 terug. Onthoud: controleer je antwoord door op te tellen: €3,50 + €1,50 = €5,00 ✓.",
        "solutionSteps": [
          "Betaald: €5,00, prijs: €3,50",
          "Wisselgeld = €5,00 − €3,50 = €1,50",
          "Geef terug: €1 + 50 cent = €1,50"
        ]
      }
    }
  ]
}